import { createGlobalStyle } from "styled-components";
export const GlobalSliderStyle = createGlobalStyle `
  ${(p) => p.dragging &&
    `
    * {
      cursor: grabbing !important;
    }
        `}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsU2xpZGVyU3R5bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbGlkZXIvc3R5bGVkL0dsb2JhbFNsaWRlclN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBRXRELE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFRLGlCQUFpQixDQUF1QjtJQUMxRSxDQUFDLENBQUMsRUFBRSxFQUFFLENBQ04sQ0FBQyxDQUFDLFFBQVE7SUFDVjs7OztTQUlLO0NBQ1IsQ0FBQyJ9